import { Component, OnDestroy } from '@angular/core';
import { isUndefined } from 'lodash-es';
import { Subscription } from 'rxjs';
import { NotificationService } from './notification.service';
import { NotificationType } from '../../enum/notification.enum';
import { Notification } from '../../models/reusables/notification';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html'
})
export class NotificationComponent implements OnDestroy {
  notifications: Array<Notification> = [];
  private readonly subscription: Subscription = new Subscription();

  constructor(private readonly notificationService: NotificationService) {
    this.subscription = this.notificationService.getNotification().subscribe((notification: Notification) => {
      this.notifications.unshift(notification);
      if (!isUndefined(notification.duration)) {
        window.setTimeout(() => this.closeNotification(notification), notification.duration);
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public closeNotification(notification: Notification) {
    this.notifications = this.notifications.filter(obj => obj !== notification);
  }

  public getNotificationStyles(notificationType: NotificationType | undefined) {
    const notifications = {
      0: 'warning',
      1: 'alert',
      2: 'info',
      3: 'success'
    };
    return `esf-notification--${notifications[notificationType]} is-active`;
  }
}
